import React from "react";
import { useTheme, useMediaQuery } from "@mui/material";

import { ProductsStepMobile } from "./ProductsStepMobile";
import { ProductsStepDesktop } from "./ProductsStepDesktop";

export function ProductsStep() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  return isMobile ? <ProductsStepMobile /> : <ProductsStepDesktop />;
}
